import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../state/consts.ts";

export default function ModalInfoVollgeschosse() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <p>Vollgeschosse sind die Geschosse oder auch Etagen im Gebäude, die eine Höhe von mindestens 2,30 m haben. Dazu zählen z. B. das Erdgeschoss, Obergeschosse oder Dachgeschosse. Wohnräume im Keller oder Souterrain nur, wenn deren Deckenoberkante im Mittel mehr als 1,60 m über die Geländeoberfläche hinausragt.</p>
            <img className="panel__img" src="Vollgeschosse_bestimmen_250521.png"/>
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

